export default __webpack_public_path__ + "static/media/done-page.231157a4.md";